"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAuth } from "@/contexts/auth-context";

export default function Home() {
  const router = useRouter();
  const { session, isLoading } = useAuth();

  useEffect(() => {
    // Check for OAuth parameters in the URL
    const urlParams = new URLSearchParams(window.location.search);
    const error = urlParams.get("error");
    const errorDescription = urlParams.get("error_description");
    const code = urlParams.get("code");
    const state = urlParams.get("state");

    // If we have OAuth parameters, handle them
    if (error || code || state) {
      console.log("OAuth response detected at root URL:", {
        error,
        errorDescription,
        code: code?.substring(0, 10) + "...",
        state: state?.substring(0, 10) + "...",
      });

      if (error) {
        // OAuth error - redirect to login page with error
        const loginUrl = new URL("/login", window.location.origin);
        loginUrl.searchParams.set("error", error);
        if (errorDescription) {
          loginUrl.searchParams.set("error_description", errorDescription);
        }

        console.log("Redirecting to login with error:", loginUrl.toString());
        window.location.href = loginUrl.toString();
        return;
      } else if (code && state) {
        // OAuth success - redirect to callback handler
        const callbackUrl = new URL(
          "/api/auth/callback/tastytrade",
          window.location.origin,
        );
        callbackUrl.searchParams.set("code", code);
        callbackUrl.searchParams.set("state", state);

        console.log("Redirecting to callback handler:", callbackUrl.toString());
        window.location.href = callbackUrl.toString();
        return;
      }
    }

    // Normal redirect logic
    if (!isLoading) {
      if (session) {
        router.push("/dashboard");
      } else {
        router.push("/login");
      }
    }
  }, [session, isLoading, router]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
        <p className="mt-4 text-gray-600">Loading TastyMaestro...</p>
      </div>
    </div>
  );
}
